export default __webpack_public_path__ + "static/media/char_robot.6382a55a.png";